import { V as VividElement, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';

const styles = ":host{display:contents}slot:not(:focus-within){position:absolute;display:inline;overflow:hidden;width:1px;height:1px;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap}";

class VisuallyHidden extends VividElement {
}

const VisuallyHiddenTemplate = () => html`<slot></slot>`;

const visuallyHiddenDefinition = defineVividComponent(
  "visually-hidden",
  VisuallyHidden,
  VisuallyHiddenTemplate,
  [],
  {
    styles
  }
);
const registerVisuallyHidden = createRegisterFunction(
  visuallyHiddenDefinition
);

export { VisuallyHidden as V, registerVisuallyHidden as r, visuallyHiddenDefinition as v };
